import React from 'react';
import { Alert, Box } from 'pounceV2';
import { extractErrorMessage } from 'Helpers/utils';
import { ApolloError } from '@apollo/client';

const NotificationsErrorV3 = ({ error }: { error: ApolloError }) => {
  const hasError = Boolean(error);

  return hasError ? (
    <Box p={6}>
      <Alert
        variant="error"
        title="Couldn't load your Notifications"
        description={
          extractErrorMessage(error) ||
          'There was an error when performing your request, please contact support@runpanther.io'
        }
      />
    </Box>
  ) : null;
};

export default NotificationsErrorV3;
